/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import { HTTP_METHOD } from "@nf/constants";
import { getMediaChannelFromScreenId } from "../../../../helpers";
import { httpService } from "../../../../services";
import {
  IAssetLastViewedEpisode,
  IFavoritesAssetModel,
  IUserPlayHistoryModel,
  IListModel,
  IAssetModel,
  IUserPlayHistoryRequestModel,
} from "../models";

export class UserMediaPropertiesService {
  get url(): string {
    return "/v1";
  }

  public getUserPlayHistory = (
    params: IUserPlayHistoryRequestModel
  ): Promise<IListModel<IUserPlayHistoryModel[]>> =>
    httpService.request<IListModel<IUserPlayHistoryModel[]>>({
      axiosConfig: {
        params,
      },
      method: HTTP_METHOD.GET,
      url: `${this.url}/userplayhistory/lastviewedoffset`,
    });

  public deleteUserPlayHistory = (id: string | number): Promise<void> =>
    httpService.request<void>({
      method: HTTP_METHOD.DELETE,
      url: `${this.url}/userplayhistory/lastviewed/asset/${id}`,
    });

  public getUserPlayHistoryList = (): Promise<IListModel<IAssetModel[]>> =>
    httpService.request<IListModel<IAssetModel[]>>({
      method: HTTP_METHOD.GET,
      url: `${this.url}/recommend/continue`,
    });

  public getUserLastViewedEpisode = (
    assetId: string | number
  ): Promise<IAssetLastViewedEpisode> =>
    httpService.request<IAssetLastViewedEpisode>({
      method: HTTP_METHOD.GET,
      url: `${this.url}/userplayhistory/continue/tvshow/${assetId}`,
    });

  public getUserFavouriteList = (
    channel?: string
  ): Promise<IFavoritesAssetModel[]> => {
    const params = channel && {
      tagIds: getMediaChannelFromScreenId(channel),
    };

    return httpService.request<IFavoritesAssetModel[]>({
      axiosConfig: {
        params,
      },
      method: HTTP_METHOD.GET,
      url: `${this.url}/preferences/list/favorites/asset`,
    });
  };

  public getUserFavouriteListByComponentUrl = (
    url: string
  ): Promise<IFavoritesAssetModel[]> =>
    httpService.request<IFavoritesAssetModel[]>({
      method: HTTP_METHOD.GET,
      url,
    });

  public addToFavourites = (assetId: string | number): Promise<void> =>
    httpService.request<void>({
      method: HTTP_METHOD.POST,
      url: `${this.url}/preferences/list/favorites/asset/${assetId}`,
      data: {},
    });

  public removeFromFavourites = (assetId: string | number): Promise<void> =>
    httpService.request<void>({
      method: HTTP_METHOD.DELETE,
      url: `${this.url}/preferences/list/favorites/asset/${assetId}`,
    });
}
